import e from "./ghl-ui.es1505.js";
import m from "./ghl-ui.es1326.js";
import n from "./ghl-ui.es1466.js";
function f(r, t) {
  n(2, arguments);
  var o = e(t), a = o * 3;
  return m(r, a);
}
export {
  f as default
};
